(function () {

  var categories = document.querySelectorAll('.js-main-category')
  if(!categories) return false

  var currentWidth
  window.addEventListener('resize', addClass)
  addClass()

  var observer = new MutationObserver(checkBodyVisible);
  observer.observe(window.document.body, {attributes: true});

  function checkBodyVisible() {
    if(window.document.body.style.visibility == 'visible') {
      observer.disconnect();
      currentWidth = 0
      addClass()
    }
  }

  function addClass() {

    if (currentWidth == window.innerWidth) {
      return
    }

    for(var i = 0; i < categories.length; i++) {
      var list = categories[i].querySelectorAll('li')
      var beforeTop = 0
      var isOdd = false
      for (var j = 0; j < list.length; j++) {
        var top = list[j].getBoundingClientRect().top
        if (beforeTop !== top) isOdd = !isOdd
        list[j].classList.remove('is-even')
        list[j].classList.remove('is-odd')
        list[j].classList.add(isOdd? 'is-odd':'is-even')
        beforeTop = top
      }
    }

    currentWidth = window.innerWidth-1
  }

}());

